import React from "react";
import styles from "./statusBadge.module.css";
import { DeclineIcon } from "../../../../../../../../../../Components/Icons/declineIcon";
import { RoundApproveIcon } from "../../../../../../../../../../Components/Icons/roundApproveIcon";

interface StatusBadgeProps {
    isActive: boolean;
}   

export const StatusBadge = ({ isActive }: StatusBadgeProps) => {
    return (
        <div className={`${styles.statusBadge} ${isActive ? styles.active : styles.inactive}`}>
            {isActive ? <RoundApproveIcon /> : <DeclineIcon fillColor="#B42318" width={16} height={16} />}
            {isActive ? "ACTIVE" : "INACTIVE"}
        </div>
    )
}
